// extracted by mini-css-extract-plugin
export default {"imgFullScreenContainer":"ReviewViewer_imgFullScreenContainer__RBrrZ","imgCanvasContainer":"ReviewViewer_imgCanvasContainer__vMLlv","imgCanvas":"ReviewViewer_imgCanvas__uiZ5u"};